import { render, staticRenderFns } from "./examAnswer.vue?vue&type=template&id=42d8a932&scoped=true"
import script from "./examAnswer.vue?vue&type=script&lang=js"
export * from "./examAnswer.vue?vue&type=script&lang=js"
import style0 from "./examAnswer.vue?vue&type=style&index=0&id=42d8a932&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d8a932",
  null
  
)

export default component.exports